export default __webpack_public_path__ + "static/media/Support.6a1a8228.png";